import { config } from '../../../config';
import { restClient } from '../../shared/services/API/backend';
import {
    GetAvailabilitiesInput,
    Availability,
    DeleteAppointmentInput,
    Appointment,
    GetAppointmentInput,
    GetCustomerAppointmentsInput,
    UpdateAppointmentInput,
    CreateAppointmentInput,
    GetCustomerInput,
    Customer,
    RequestRefInput,
    AppointmentType,
    AppointmentStatus,
} from '../models';

export const appointmentService = {
    getAvailabilities: async ({ typeId, date }: GetAvailabilitiesInput): Promise<Availability[]> => {
        const response = await restClient.get<Availability[]>(
            `${config.backend.rest.weddingUrl}/dressfittingavailability`,
            {
                params: {
                    typeId,
                    date,
                },
            },
        );
        return response.data;
    },
    getCustomer: async ({ id }: GetCustomerInput): Promise<Customer> => {
        const response = await restClient.get<Customer>(`${config.backend.rest.weddingUrl}/dressfittingcustomer/${id}`);
        return response.data;
    },
    getAppointment: async ({ id }: GetAppointmentInput): Promise<Appointment> => {
        const response = await restClient.get<Appointment>(`${config.backend.rest.weddingUrl}/appointment/${id}`);
        return response.data;
    },
    getAppointments: async ({ customerId }: GetCustomerAppointmentsInput): Promise<Appointment[]> => {
        const response = await restClient.get<Appointment[]>(
            `${config.backend.rest.weddingUrl}/dressfittingcustomer/${customerId}/appointments`,
        );
        return response.data;
    },
    createAppointment: async (body: CreateAppointmentInput): Promise<AppointmentStatus> => {
        const response = await restClient.post<AppointmentStatus>(
            `${config.backend.rest.weddingUrl}/appointment`,
            body,
        );
        return response.data;
    },
    updateAppointment: async (body: UpdateAppointmentInput): Promise<AppointmentStatus> => {
        const response = await restClient.put<AppointmentStatus>(`${config.backend.rest.weddingUrl}/appointment`, body);
        return response.data;
    },
    deleteAppointment: async ({ id }: DeleteAppointmentInput): Promise<void> => {
        await restClient.delete<void>(`${config.backend.rest.weddingUrl}/appointment/${id}`);
    },
    requestAppointmentRef: async ({ email, phoneNumber }: RequestRefInput): Promise<void> => {
        await restClient.get<void>(
            `${config.backend.rest.weddingUrl}/appointment/reference?${email ? `email=${email}` : ''}${
                email && phoneNumber ? '&' : ''
            }${phoneNumber ? `phoneNumber=${phoneNumber}` : ''}`,
        );
    },
    getAppointmentTypes: async (): Promise<AppointmentType[]> => {
        const response = await restClient.get<AppointmentType[]>(`${config.backend.rest.weddingUrl}/appointmentType`);
        return response.data;
    },
};
